import { privateFetch } from "api/privateFetch";

/**
 * @typedef {{id: number; cifNumber: number; messageType: string; messageTypeId: number; message: string; createdOn: string; messageSeenStatus: number}} Response
 */

/**
 * Get notifications
 * @param {number} cifNumber User ID
 * @returns {Promise<Response[]>} Response
 */
const getNotifications = async (cifNumber) => {
  const { data } = await privateFetch.get(`/notifications/${cifNumber}`);
  return data;
};

export default getNotifications;
